import cn from 'classnames';
import { FC } from 'react';

import { SanitizeMode } from '@/shared/text';
import { ContentMobileBehavior, CtaVariant } from '@/shared/types';

import styles from './Row.module.scss';
import { Topic, TopicRow } from './Topic';

interface Props {
  topicsAsBoxes: boolean;
  topicsWithTwoColumns?: boolean;
  topicsWithFourColumns?: boolean;
  topicsWithRichDescriptions?: boolean;
  topicsWithFullCardLinks?: boolean;
  topicBackgroundColorClassName: string;
  ctaVariant: CtaVariant;
  contentMobileBehavior: ContentMobileBehavior;
  topics: TopicRow[];
  locale: string;
}

export const Row: FC<Props> = ({
  locale,
  contentMobileBehavior,
  topicsAsBoxes,
  topicsWithTwoColumns = false,
  topicsWithFourColumns = false,
  topicsWithRichDescriptions = false,
  topicsWithFullCardLinks = false,
  topicBackgroundColorClassName,
  topics,
  ctaVariant,
}) => {
  const scroll = contentMobileBehavior === 'scroll' || topicsWithTwoColumns;
  const swipe = contentMobileBehavior === 'swipe' && !topicsWithTwoColumns;

  return (
    <div
      className={cn({
        [styles.contentContainer]: scroll,
        [styles.contentContainerSwipable]: swipe,
        [styles.asBoxes]: topicsAsBoxes,
        [styles.twoColumns]: topicsWithTwoColumns,
        [styles.fourColumns]: topicsWithFourColumns && !topicsWithTwoColumns,
      })}
    >
      {topics.map((topic, index) => {
        const key = index;
        return (
          <Topic
            key={key}
            className={cn({
              [styles.contentSwipable]: swipe,
            })}
            backgroundColorClassName={topicBackgroundColorClassName}
            ctaVariant={ctaVariant}
            fullCardLink={topicsWithFullCardLinks}
            asBox={topicsAsBoxes}
            descriptionSanitizeMode={
              topicsWithTwoColumns || topicsWithRichDescriptions
                ? SanitizeMode.MULTIPLE_LINE
                : SanitizeMode.SINGLE_LINE
            }
            locale={locale}
            {...topic}
          />
        );
      })}
    </div>
  );
};
